/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getPaymentLocationDetails } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useGetPaymentLocationDetails(referenceNumber: string, options?: UseQueryOptions) {
  return useQuery({
    queryKey: userQueryKeys.paymentLocationDetails(referenceNumber),
    queryFn: () => getPaymentLocationDetails(referenceNumber).then((res) => res.data),
    ...options,
  });
}
